import { Component, inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@codeandweb/ngx-translate';
import { Button } from 'primeng/button';
import { AppService } from '../../../services/app.service';
import { SnsType } from '../../../enum/app.enum';
import { SnsList } from '../../../interfaces/app.interface';

@Component({
  selector: 'app-footer',
  imports: [TranslatePipe, Button],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer implements OnInit {
  public appService = inject(AppService);
  public isCompanyInfoView: boolean = false;
  public snsLink: any;
  public snsList: SnsList[] = [
    {
      src: '/images/common/facebook-logo.svg',
      id: SnsType.Facebook
    },
    { src: '/images/common/naver-logo.svg', id: SnsType.Naver },
    { src: '/images/common/insta-logo.svg', id: SnsType.Instagram },
    { src: '/images/common/youtube-logo.svg', id: SnsType.Youtube },
    { src: '/images/common/github-logo.svg', id: SnsType.Github }
  ];

  async ngOnInit() {
    this.snsLink = await this.appService.getSnsLink();
  }

  goToSns(sns: SnsType) {
    switch (sns) {
      case SnsType.Facebook:
      case SnsType.Instagram:
      case SnsType.Youtube:
        this.appService.goExternal(this.snsLink[sns][this.appService.usedLanguage()]);
        break;

      case SnsType.Github:
        this.appService.goExternal('https://github.com/toonsquare');
        break;
      case SnsType.Naver:
        this.appService.goExternal('https://blog.naver.com/tooning_io');
        break;
    }
  }
}
